export interface ISelectValue {
    Id: string | number | boolean,
    Libelle: string
}
interface IProps {
    nullValue?: string,
    options?: ISelectValue[],
    //selectedId?: string | number
}
//, selectedId
const SelectOptions: React.FC<IProps> = ({ nullValue, options }: IProps) => {
    return (
        <>
            {nullValue && (
                <option
                    key={0}
                    value={"DEFAULT"}
                    className="pae-detail-label"
                >
                    {nullValue}
                </option>
            )}
            {options?.map((item, i) => {
                return (
                    <option key={i + "_" + item.Id} value={item.Id.toString()} > 
                        {item.Libelle}
                    </option>
                );
            })}
        </>
    )
}
//selected={selectedId ? item.Id.toString() === selectedId.toString() : false}

export default SelectOptions